import { render } from "./SideBar.vue?vue&type=template&id=44abce88"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=44abce88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SidebarPlugin/SideBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44abce88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44abce88', __exports__)) {
    api.reload('44abce88', __exports__)
  }
  
  module.hot.accept("./SideBar.vue?vue&type=template&id=44abce88", () => {
    api.rerender('44abce88', render)
  })

}


export default __exports__